(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[310],{

/***/ 6213:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/momentum",
      function () {
        return __webpack_require__(75186);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 44177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fg": function() { return /* binding */ StyledLink; },
/* harmony export */   "zK": function() { return /* binding */ StatusColorMap; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_ssr__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33369);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var _sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18518);
/* harmony import */ var _sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6848);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var _styled_system_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37947);
/* harmony import */ var _sparkpost_design_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26581);
/* harmony import */ var _sparkpost_design_tokens__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_sparkpost_design_tokens__WEBPACK_IMPORTED_MODULE_3__);









function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  cursor: pointer;\n  overflow-wrap: anywhere;\n\n  &,\n  &:visited,\n  &:active {\n    text-decoration: none;\n    ",
        "\n  }\n\n  &:hover {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  cursor: pointer;\n  &:hover {\n    ",
        "\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].a(_templateObject(), function(param) {
    var $active = param.$active, $level = param.$level;
    return (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)({
        py: '200',
        pr: '700',
        pl: "calc(".concat(_sparkpost_design_tokens__WEBPACK_IMPORTED_MODULE_3__.tokens.spacing_500, " + ").concat(_sparkpost_design_tokens__WEBPACK_IMPORTED_MODULE_3__.tokens.spacing_200, " * ").concat($level, ")"),
        bg: $active ? 'blue.700' : 'transparent',
        color: $active ? 'white' : 'gray.900'
    });
}, function(param) {
    var $active = param.$active;
    return (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)({
        bg: $active ? 'blue.700' : 'gray.200',
        color: $active ? 'white' : 'gray.900'
    });
});
var StatusColorMap = {
    none: 'green.700',
    minor: 'yellow.400',
    major: 'brand.orange',
    critical: 'red.700'
};
var BaseNavigation = function(props) {
    var _data = props.data, data = _data === void 0 ? [] : _data, title = props.title, titleLink = props.titleLink, children = props.children;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        width: [
            '100%',
            null,
            '260px'
        ],
        position: "sticky",
        top: "0",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                href: titleLink,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
                        display: [
                            'none',
                            null,
                            'inline-block'
                        ],
                        fontSize: "200",
                        lineHeight: "200",
                        fontWeight: "semibold",
                        pl: "500",
                        children: title
                    })
                })
            }),
            data.map(function(item, i) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, _objectSpread({}, item), i);
            }),
            children
        ]
    }));
};
var getActiveUrl = function(location) {
    if (!location) {
        return '';
    }
    return location.pathname + location.hash;
};
var findActiveChild = function(items, activeUrl) {
    return items.find(function(item) {
        var hasDirectChild = item.link == activeUrl;
        if (!hasDirectChild && item.items) {
            return findActiveChild(item.items, activeUrl);
        }
        return hasDirectChild;
    });
};
var Chevron = function(props) {
    var expanded = props.expanded;
    return expanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_7__/* .KeyboardArrowUp */ .Q6b, {
        size: 18
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_7__/* .KeyboardArrowDown */ .WdC, {
        size: 18
    });
};
var StyledChevronWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu)(_templateObject1(), _sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__/* .styles.buttonReset */ .W2.buttonReset, function(param) {
    var $active = param.$active;
    return (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)({
        color: $active ? 'white' : 'blue.700'
    });
}, function(param) {
    var $active = param.$active;
    return (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)({
        color: $active ? 'white' : 'inherit'
    });
});
var Item = function(props) {
    var link = props.link, title = props.title, items = props.items, _level = props.level, level = _level === void 0 ? 0 : _level;
    var ref = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), active = ref[0], setActive = ref[1];
    var ref1 = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), expanded = ref1[0], setExpanded = ref1[1];
    var environment = (0,utils_ssr__WEBPACK_IMPORTED_MODULE_8__/* .getWindow */ .J)();
    var activeUrl = getActiveUrl(environment === null || environment === void 0 ? void 0 : environment.location);
    var hasActiveChild = items && findActiveChild(items, activeUrl);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        var isExpanded = Boolean(hasActiveChild) || activeUrl === link || activeUrl.includes(link);
        var isActive = activeUrl === link;
        setExpanded(isExpanded);
        setActive(isActive);
    }, [
        link,
        activeUrl
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        fontSize: "200",
        lineHeight: "200",
        position: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                href: link,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                    $active: active,
                    $level: level,
                    children: title
                })
            }),
            items && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledChevronWrapper, {
                as: "button",
                position: "absolute",
                right: "400",
                top: "6px",
                width: "24px",
                height: "24px",
                onClick: function() {
                    return setExpanded(!expanded);
                },
                "aria-expanded": expanded,
                "aria-controls": "".concat(link, "__items"),
                $active: active,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__/* .ScreenReaderOnly */ .uy, {
                        children: "Expand Menu"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Chevron, {
                        expanded: expanded
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
                id: "".concat(link, "__items"),
                children: expanded && items && items.map(function(item, i) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, _objectSpread({
                        level: level + 1
                    }, item), i);
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (BaseNavigation);


/***/ }),

/***/ 31277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18518);
/* harmony import */ var components_site_headerButtons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64847);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var _layoutWrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34109);
/* harmony import */ var _layoutInnerContent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22545);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Layout = function(props) {
    var children = props.children, navigationComponent = props.navigationComponent;
    var ref = (0,_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .useDrawer */ .yT)(), getDrawerProps = ref.getDrawerProps, getActivatorProps = ref.getActivatorProps;
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().asPath;
    var category = asPath.split('/')[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layoutWrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Drawer */ .dy, _objectSpread({}, getDrawerProps(), {
                position: "right",
                id: "mobile-menu",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Drawer.Header */ .dy.Header, {
                        children: [
                            category === 'momentum' ? 'Momentum' : 'Support',
                            " Documentation"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Drawer.Content */ .dy.Content, {
                        children: navigationComponent
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Drawer.Footer */ .dy.Footer, {
                        children: !props.hideDrawerButtons && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_site_headerButtons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                    })
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layoutInnerContent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                getActivatorProps: getActivatorProps,
                hideDrawerButtons: props.hideDrawerButtons,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    display: "flex",
                    width: "100%",
                    bg: "white",
                    border: "400",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                            flex: "0",
                            borderRight: "400",
                            display: [
                                'none',
                                null,
                                'block'
                            ],
                            children: navigationComponent
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                            py: "500",
                            flex: "1",
                            id: "main-content",
                            overflow: "hidden",
                            position: "relative",
                            children: children
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 75186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ momentum; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@sparkpost/matchbox/dist/matchbox.esm.js + 50 modules
var matchbox_esm = __webpack_require__(18518);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@styled-system/css/dist/index.esm.js
var index_esm = __webpack_require__(37947);
// EXTERNAL MODULE: ./utils/ssr.ts
var ssr = __webpack_require__(33369);
;// CONCATENATED MODULE: ./components/site/momentumHomePageContent.tsx







function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  text-decoration: none;\n\n  &,\n  &:visited {\n    ",
        "\n  }\n\n  &:hover {\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var content = [
    [
        {
            label: 'Momentum 4.x Documentation',
            level: 1
        },
        {
            label: 'Momentum 4.x API v1',
            url: 'https://support.messagesystems.com/docs/web-rest/v1_index.html',
            level: 2
        },
        {
            label: 'Momentum 4.x Reference Manual',
            url: '/momentum/4/',
            level: 2
        },
        {
            label: 'Introduction',
            url: '/momentum/4/p-intro',
            level: 3
        },
        {
            label: 'Installing Momentum',
            url: '/momentum/4/p-intro',
            level: 3
        },
        {
            label: 'Configuring Momentum',
            url: '/momentum/4/p-configuration',
            level: 3
        },
        {
            label: 'Logging',
            url: '/momentum/4/p-logs',
            level: 3
        },
        {
            label: 'Using the system Console',
            url: '/momentum/4/p-operations',
            level: 3
        },
        {
            label: 'SMTP Injection',
            url: '/momentum/4/p-smtp-injections',
            level: 3
        },
        {
            label: 'Message Generation using HTTP',
            url: '/momentum/4/p-http-rest',
            level: 3
        },
        {
            label: 'Reporting and Engagement Tracking',
            url: '/momentum/4/p-analytics',
            level: 3
        },
        {
            label: 'Writing Policy',
            url: '/momentum/4/p-policy',
            level: 3
        },
        {
            label: 'Lua Functions, Modules, Options and Commands',
            url: '/momentum/4/p-reference',
            level: 3
        },
        {
            label: 'Running in a Container',
            url: '/momentum/4/p-container',
            level: 3
        }, 
    ],
    [
        {
            label: 'Momentum 3.x Documentation',
            level: 1
        },
        {
            label: 'Momentum Reference Manual (3.x)',
            url: '/momentum/3/3-reference/',
            level: 2
        },
        {
            label: 'Modules 3.x Summary',
            url: '/momentum/3/3-reference/modules-summary/',
            level: 3
        },
        {
            label: 'Options 3.x Summary',
            url: '/momentum/3/3-reference/options-summary/',
            level: 3
        },
        {
            label: 'Listener Options 3.x Summary',
            url: '/momentum/3/3-reference/ecelerity-conf/#table-listener-options',
            level: 3
        },
        {
            label: 'Lua Functions 3.x Summary',
            url: '/momentum/3/3-reference/3-reference-lua-summary-table/',
            level: 3
        },
        {
            label: 'Console Commands 3.x Summary',
            url: '/momentum/3/3-reference/console-commands-summary-table/',
            level: 3
        },
        {
            label: 'Executable Commands 3.x Summary',
            url: '/momentum/3/3-reference/exe-summary-table/',
            level: 3
        },
        {
            label: 'Sieve Functions 3.x Summary',
            url: '/momentum/3/3-reference/sieve-ref-3-function-summary/',
            level: 3
        },
        {
            label: 'Momentum for Mobile Push Notifications',
            url: '/momentum/3/3-push/',
            level: 2
        },
        {
            label: 'Default Policy User Guide',
            url: '/momentum/3/3-policy/',
            level: 2
        },
        {
            label: 'Adaptive Delivery User Guide',
            url: '/momentum/3/3-ad/',
            level: 2
        },
        {
            label: 'Momentum REST Injector',
            url: '/momentum/3/3-rest/',
            level: 2
        },
        {
            label: 'Momentum API Reference (3.x)',
            url: '/momentum/3/3-api/',
            level: 2
        }, 
    ],
    [
        {
            label: 'Mobile Momentum Documentation',
            level: 1
        },
        {
            label: 'Mobile Momentum Reference Manual',
            url: '/momentum/mobile/mobile-reference/',
            level: 2
        },
        {
            label: 'Mobile Momentum Quick Start',
            url: '/momentum/mobile/mobile-quick-start/',
            level: 2
        },
        {
            label: 'Mobile Momentum Developer Guide',
            url: '/momentum/mobile/mobile-developer-guide/',
            level: 2
        }, 
    ], 
];
var StyledLink = styled_components_browser_esm["default"].a(_templateObject(), (0,index_esm/* default */.ZP)({
    color: 'gray.900'
}), (0,index_esm/* default */.ZP)({
    color: 'blue.700'
}), function(param) {
    var level = param.level;
    if (level === 2) {
        return (0,index_esm/* default */.ZP)({
            fontWeight: 'normal',
            fontSize: '400',
            lineHeight: '400'
        });
    }
    return (0,index_esm/* default */.ZP)({
        fontWeight: 'normal',
        pl: '600',
        textDecoration: 'underline'
    });
});
var TocLink = /*#__PURE__*/ react.forwardRef(function TocLink(props, ref) {
    var level = props.level, url = props.url, children = props.children;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
        href: url,
        level: level,
        ref: ref,
        children: children
    }));
});
var MomentumHomePageContent = function() {
    // Hack to bypass a matchbox bug
    // TypeError: Cannot read property 'matches' of undefined
    // Panel relies on browser media queries which are not available on server
    if (!(0,ssr/* getWindow */.J)()) {
        return null;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
        px: "500",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Stack */.Kq, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Text */.xv, {
                    fontSize: "600",
                    lineHeight: "600",
                    fontWeight: "semibold",
                    children: "Momentum Documentation"
                }),
                content.map(function(category, i) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Panel */.s_, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Panel.Section */.s_.Section, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Stack */.Kq, {
                                space: "200",
                                children: category.map(function(param, j) {
                                    var label = param.label, url = param.url, level = param.level;
                                    if (url) {
                                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: url,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TocLink, {
                                                url: url,
                                                level: level,
                                                children: label
                                            })
                                        }, "".concat(i, "-").concat(j)));
                                    }
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Text */.xv, {
                                        fontWeight: "semibold",
                                        fontSize: "400",
                                        lineHeight: "400",
                                        children: label
                                    }, "".concat(i, "-").concat(j)));
                                })
                            })
                        })
                    }, i));
                })
            ]
        })
    }));
};
/* harmony default export */ var momentumHomePageContent = (MomentumHomePageContent);

// EXTERNAL MODULE: ./components/site/seo.tsx
var seo = __webpack_require__(51289);
// EXTERNAL MODULE: ./components/site/momentumLayout.tsx + 1 modules
var momentumLayout = __webpack_require__(64114);
// EXTERNAL MODULE: ./context/categories.tsx
var categories = __webpack_require__(18650);
;// CONCATENATED MODULE: ./pages/momentum/index.tsx





var IndexPage = function(props) {
    var categoryData = props.categoryData;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(categories/* CategoriesProvider */.z, {
        data: categoryData,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                title: "Momentum Documentation - SparkPost",
                description: "SparkPost Momentum Documentation"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(momentumLayout/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(momentumHomePageContent, {})
            })
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var momentum = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [398,371,114,774,888,179], function() { return __webpack_exec__(6213); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);